import { UseQueryOptions } from '@tanstack/react-query';

import { equipmentBrowserGetEquipmentBrowserConfig } from '@repo/sdk/funcs/equipmentBrowserGetEquipmentBrowserConfig';
import { EquipmentBrowserConfig } from '@repo/sdk/models/components';
import { SDKError } from '@repo/sdk/models/errors';
import { GetEquipmentBrowserConfigRequest } from '@repo/sdk/models/operations';

import { GaiaClientFunction } from '@/client/types';
import { displayTemplateSourceKey } from '@/queries/gaia-api/display-template-source-key';
import { GaiaQueryWithAgentId } from '@/queries/types';

interface GetEquipmentBrowserConfigQueryProps extends GaiaQueryWithAgentId {
  client: GaiaClientFunction;
}

export const getEquipmentBrowserConfigQuery = ({
  agentId,
  client,
}: GetEquipmentBrowserConfigQueryProps): UseQueryOptions<
  EquipmentBrowserConfig,
  SDKError,
  EquipmentBrowserConfig | undefined
> => {
  return {
    enabled: !!agentId,
    queryKey: [agentId, 'getEquipmentBrowserConfig', displayTemplateSourceKey(client)],
    queryFn: () =>
      client<GetEquipmentBrowserConfigRequest, EquipmentBrowserConfig>({
        gaiaFunc: equipmentBrowserGetEquipmentBrowserConfig,
        request: {
          agentId: agentId!,
        },
      }),
    staleTime: Infinity,
  };
};
